import CountUp from 'react-countup';
import { FaBolt } from 'react-icons/fa';
import { FaRegLightbulb } from 'react-icons/fa6';
import { IoArrowForwardSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import about1 from '../../../../Images/background/about-img-1.jpg';
import about2 from '../../../../Images/background/about-img-2.jpg';
import courseIcons1 from '../../../../Images/icons/course-3.svg';
import courseIcons2 from '../../../../Images/icons/instructor-3.svg';
import icons1 from '../../../../Images/icons/learn.svg';
import icons4 from '../../../../Images/icons/lecture-1.png';
import courseIcons3 from '../../../../Images/icons/lifetime-course.svg';
import icons3 from '../../../../Images/icons/online-education.png';
import icons2 from '../../../../Images/icons/support.svg';

import './ItesseractAbout.css';

const ItesseractAbout = () => {
  return (
    <section className='pt-[60px] pb-[60px]'>
      <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
        <div className='number-background py-16 rounded-[10px] px-10'>
          <div className='grid grid-cols-1 gap-16 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2'>
            <div>
              <div className='about-img-wrap wow fade-in-left'>
                <div className='about-img-1'>
                  <img src={about1} alt='icons' />
                </div>
                <div className='about-img-2'>
                  <img src={about2} alt='icons' />
                </div>
                <div className='about-contact'>
                  <div className='icon'>
                    <FaRegLightbulb />
                  </div>
                  <div className='content'>
                    <a className='text-xl' href='#'>
                      10+
                    </a>
                    <span>Years Of Experience</span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <section className='section-heading'>
                <h4 className='bg-primary text-white text-[15px] font-medium inline-flex items-center gap-2.5 mb-4 relative   rounded-full section-padding'>
                  <span className='background-color-section text-primary text-[14px] w-7 h-7 rounded-full flex items-center justify-center'>
                    <FaBolt />
                  </span>
                  Get More About Us
                </h4>
                <h2 className='text-[20px] sm:text-[22px] md:text-[25px] lg:text-[30px] xl:text-[35px] font-semibold leading-tight mb-5'>
                  Focused on Legacy & Expertise
                </h2>
                <p className='text-[15px] text-[#6C706F] mb-6'>
                  With a solid foundation built over ten successful years, M.
                  Solaiman Technical Training Center stands as a testament to
                  consistent quality and career transformation. Our decade-long
                  journey has been defined by adapting to industry shifts,
                  refining our specialized curriculum, and graduating hundreds
                  of competent technicians. This extensive experience ensures
                  that our programs are not just current, but are also deeply
                  rooted in proven, real-world methodologies, providing every
                  student with a reliable advantage in the competitive job
                  market.
                </p>
              </section>
              <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2'>
                <div className='flex items-center gap-4'>
                  <div className='bg-[#ffffff] number-shadow border border-[#E0E5EB] rounded-[10px] w-[50px] h-[50px] flex items-center justify-center'>
                    <img
                      width='35'
                      height='35'
                      className='object-cover'
                      src={icons3}
                      alt='icons'
                    />
                  </div>
                  <div>
                    <h4 className='text-primary text-[24px] font-bold leading-normal'>
                      <CountUp
                        end={2000}
                        duration={2.75}
                        enableScrollSpy={true}
                      />
                      +
                    </h4>
                    <p className='text-[#4E5055] font-medium text-[15px]'>
                      Successful student
                    </p>
                  </div>
                </div>

                <div className='flex items-center gap-4'>
                  <div className='bg-[#ffffff] number-shadow border border-[#E0E5EB] rounded-[10px] w-[50px] h-[50px] flex items-center justify-center'>
                    <img
                      width='35'
                      height='35'
                      className='object-cover'
                      src={icons4}
                      alt='icons'
                    />
                  </div>
                  <div>
                    <h4 className='text-primary text-[24px] font-bold leading-normal'>
                      <CountUp
                        end={100}
                        duration={2.75}
                        enableScrollSpy={true}
                      />
                      %
                    </h4>
                    <p className='text-[#4E5055] font-medium text-[15px]'>
                      Success Rate
                    </p>
                  </div>
                </div>
                <div className='flex items-center gap-4 card-shodows'>
                  <div>
                    <div className='bg-primary   rounded-full w-[65px] h-[65px] flex items-center justify-center'>
                      <img
                        width='43'
                        height='43'
                        className='object-cover icons-card'
                        src={icons1}
                        alt='icons'
                      />
                    </div>
                  </div>
                  <div>
                    <h4 className=' text-[18px] font-semibold leading-normal capitalize pb-1'>
                      Flexible Learning
                    </h4>
                    <p className='text-[#7c7c7e] font-medium text-[15px]'>
                      Learn at your own pace anytime, anywhere.
                    </p>
                  </div>
                </div>
                <div className='flex items-center gap-4 card-shodows'>
                  <div>
                    <div className='bg-primary   rounded-full w-[65px] h-[65px] flex items-center justify-center'>
                      <img
                        width='43'
                        height='43'
                        className='object-cover icons-card'
                        src={icons2}
                        alt='icons'
                      />
                    </div>
                  </div>
                  <div>
                    <h4 className=' text-[18px] font-semibold leading-normal capitalize pb-1'>
                      24/7 Live Support
                    </h4>
                    <p className='text-[#7c7c7e] font-medium text-[15px]'>
                      Our support team is always here to help.
                    </p>
                  </div>
                </div>
              </div>
              <div className='mt-7'>
                <Link to='/about' className='primary-btn'>
                  Read More
                  <IoArrowForwardSharp className='ml-2' />
                </Link>
              </div>
            </div>
          </div>
          <div className='grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 pt-[50px]'>
            <div className='feature-item relative'>
              <div className='feature-content'>
                <span className='count'>01</span>
                <div className='feature-icon'>
                  <img src={courseIcons1} alt='icons' />
                </div>
                <div className='feature-info'>
                  <h4 className=' text-[20px] font-semibold leading-normal capitalize pb-3'>
                    Experienced Instructors
                  </h4>
                  <p className='text-[#757f95] text-[15px]'>
                    Learn from decade-experienced experts. They provide
                    industry-relevant guidance for advanced skills like 6G
                    Welding.
                  </p>
                </div>
              </div>
            </div>
            <div className='feature-item relative'>
              <div className='feature-content'>
                <span className='count'>02</span>
                <div className='feature-icon'>
                  <img src={courseIcons2} alt='icons' />
                </div>
                <div className='feature-info'>
                  <h4 className=' text-[20px] font-semibold leading-normal capitalize pb-3'>
                    Facilities Including Hostel
                  </h4>
                  <p className='text-[#757f95] text-[15px]'>
                    Modern labs and workshops are available. Convenient on-site
                    hostel accommodation supports focused learning.
                  </p>
                </div>
              </div>
            </div>
            <div className='feature-item relative'>
              <div className='feature-content'>
                <span className='count'>03</span>
                <div className='feature-icon'>
                  <img src={courseIcons3} alt='icons' />
                </div>
                <div className='feature-info'>
                  <h4 className=' text-[20px] font-semibold leading-normal capitalize pb-3'>
                    Certificate Provided
                  </h4>
                  <p className='text-[#757f95] text-[15px]'>
                    Receive a recognized certificate upon completion, validating
                    your technical skills for global employment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ItesseractAbout;
